import { ProductVariant } from '@/types/product'
import { create } from 'zustand'

interface ProductDetailStore {
  variantActive: ProductVariant | null
  giftData: {
    id: string
    optionId: string
    price: number
  }
  setVariantActive: (variant: ProductVariant) => void
  setGiftData: (data: { id: string; optionId: string; price: number }) => void
}

export const useProductDetail = create<ProductDetailStore>((set) => ({
  variantActive: null,
  giftId: null,
  giftOptionId: null,
  giftData: {
    id: '',
    optionId: '',
    price: 0,
  },
  setVariantActive: (variant) => set({ variantActive: variant }),
  setGiftData: (data) => set({ giftData: data }),
}))
